import { dodgeInstance as Axios } from './axios.service';


const BookingService = {
  autoCompleteMapsBySearch(key) {
    return Axios({
      method: 'GET',
      url: `booking-service/maps/autocomplete-search-by-text/?search_text=${key}`
    });
  },

  placesApiMap(key) {
    return Axios({
      method: 'GET',
      url: `booking-service/maps/search-place-by-id/?place_id=${key}`
    });
  },

  getActiveBookingVehicleCategories(tripType) {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-organisation-profile/get_booking_category_sizes/?trip_type=${tripType}`
    })
  },

  getQuoteLeads(filter) {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-trip/get_check_quote/${filter}`,
    });
  },

  createQuote(payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-trip/check_quote/`,
      data: payload
    });
  },

  createAdminOpenTrip(payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-trip/admin_create_open_trip/`,
      data: payload
    });
  },

  checkout(id) {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-trip/${id}/checkout/`
    });
  },

  checkoutBusiness(id, businessRef) {
    return Axios({
      method: 'GET',
      url: `entity-service/business/business-tripset/${id}/checkout/`,
      headers: { entity: businessRef }
    });
  },

  createB2CTripPool(payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-trip-pool/`,
      data: payload
    });
  },

  createB2BTripPool(payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-trip-pool/create_business_trip_pool/`,
      data: payload
    });
  },

  getTrips(filter) {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-trip/${filter}`,
    });
  },

  fetchPicklist(reference) {
    return Axios({
      method: 'GET',
      url: `warehouse-service/vehicle/picklist/${reference}`
    });
  },

  getTripInfo(payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-trip/search/`,
      data: payload
    });
  },

  getOrganisationReferences() {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-business-trip-pool/get_organisation_references`,
    });
  },

  getTripPoolQuotes(tripPoolId) {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-trip-pool/${tripPoolId}/get_suggested_quotes/`,
    });
  },

  createTripPoolConfiguration(payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-business-trip-pool/`,
      data: payload
    });
  },

  getTripPoolConfiguration() {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-business-trip-pool/`,
    });
  },

  updateTripPoolConfiguration(tripPoolId, payload) {
    return Axios({
      method: 'PATCH',
      url: `booking-service/booking/booking-business-trip-pool/${tripPoolId}/`,
      data: payload
    });
  },

  deleteTripPoolConfiguration(tripPoolId) {
    return Axios({
      method: 'DELETE',
      url: `booking-service/booking/booking-business-trip-pool/${tripPoolId}/`,
    });
  },

  getTripPoolSubOrganisations() {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-business-trip-pool/get_sub_organisation_config/`,
    });
  },


  getOrganisationPoolDetails(tripPoolId, payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-trip-pool/${tripPoolId}/get_organisation_details/`,
      data: payload
    });
  },

  updateTripPool(tripPoolId, payload) {
    return Axios({
      method: 'PATCH',
      url: `booking-service/booking/booking-trip-pool/${tripPoolId}/`,
      data: payload
    });
  },

  acceptTripPoolQuote(tripPoolId, payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-trip-pool/${tripPoolId}/select_trip_pool_quote/`,
      data: payload
    });
  },

  cardCheckout(tripPoolId, callbackUrl) {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-trip-pool/${tripPoolId}/checkout/?callback=${callbackUrl}/`,
    });
  },

  walletCheckout(tripPoolId) {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-trip-pool/${tripPoolId}/walletcheckout/`,
    });
  },

  updateTrip(id, payload) {
    return Axios({
      method: 'PATCH',
      url: `booking-service/booking/booking-trip/${id}/`,
      data: payload
    });
  },

  cancelTrip(id) {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-trip/${id}/cancel/`,
    });
  },

  deleteTrip(id) {
    return Axios({
      method: 'DELETE',
      url: `booking-service/booking/booking-trip/${id}/`,
    });
  },

  getOrganisationTripTypes() {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-organisation-profile/get_organisation_trip_type/`,
    });
  },

  assignDriverToTrip(id, payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-trip/${id}/assign_driver/`,
      data: payload
    });
  },

  unAssignDriverFromTrip(id) {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-trip/${id}/unassign_driver/`,
    });
  },

  /************ STATUS UPDATE ******************/
  acceptTripRequest(payload) {
    return Axios({
      method: 'POST',
      url: `asset-service/driver/driver-accept-trip//`,
      data: payload
    });
  },

  validateTripArrival(id) {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-trip/${id}/driverarrival/`,
      headers: { entity: 'driver' }
    });
  },

  startTrip(id) {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-trip/${id}/starttrip/`,
      headers: { entity: 'driver' }
    });
  },

  confirmB2BArrival(id, payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-trip/${id}/confirm_driver_arrival/`,
      data: payload,
      headers: { entity: 'driver' }
    });
  },

  confirmB2CDelivery(id, payload) {
    return Axios({
      method: 'POST',
      url: `/booking-service/booking/booking-trip/${id}/confirm_driver_delivery/`,
      data: payload,
      headers: { entity: 'driver' }
    });
  },

  dropOffDelivery(id, payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-trip/${id}/dropofflocation/`,
      data: payload,
      headers: { entity: 'driver' }
    });
  },

  validateDelivery(id) {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-trip/${id}/driverdelivery/`,
      headers: { entity: 'driver' }
    });
  },

  reconcileDelivery(id) {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-trip/${id}/reconcile_business_trip/`
    });
  },

  /********************* ADDED SERVICES ***********************/

  applyCoupon(tripId, payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-trip/${tripId}/apply_coupon/`,
      data: payload
    });
  },

  toggleAddedServiceStatus(serviceId) {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-organisation-profile/${serviceId}/toggle_added_services/`,
    });
  },

  getOrganisationAddedServices() {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-organisation-added-services/`,
    });
  },

  createOrganisationExtras(serviceId, payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-organisation-added-services/${serviceId}/create_extras/`,
      data: payload
    });
  },

  updateOrganisationExtras(serviceId, payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-organisation-added-services/${serviceId}/update_extras/`,
      data: payload
    });
  },

  deleteOrganisationExtras(serviceId, payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-organisation-added-services/${serviceId}/delete_extras/`,
      data: payload
    });
  },

  createOrganisationCoupon(serviceId, payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-organisation-added-services/${serviceId}/create_coupon/`,
      data: payload
    });
  },

  updateOrganisationCoupon(serviceId, payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-organisation-added-services/${serviceId}/update_coupon/`,
      data: payload
    });
  },

  deleteOrganisationCoupon(serviceId, payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-organisation-added-services/${serviceId}/delete_coupon/`,
      data: payload
    });
  },

  /********************* CONFIGURATIONS ***********************/
  getOrganisationBookingProfile() {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-organisation-profile/`,
    });
  },

  createOrganisationProfile() {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-organisation-profile/`,
      data: {}
    });
  },

  updatePlatformFee(payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-organisation-profile/update_platform_commission/`,
      data: payload
    });
  },

  configureServices(payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-organisation-profile/configure_related_services/`,
      data: payload
    });
  },

  configureCustomServices(payload) {
    return Axios({
      method: 'POST',
      url: `booking-service/booking/booking-organisation-profile/configure_custom_configuration/`,
      data: payload
    });
  },

  /********************** INVENTORY **********************/
  createOrganisationInventoryProfile() {
    return Axios({
      method: 'POST',
      url: `booking-service/ims/ims-organisation-profile/`,
    });
  },

  getOrganisationInventoryProfile() {
    return Axios({
      method: 'GET',
      url: `booking-service/ims/ims-organisation-profile/`,
    });
  },


  /********************* RECONCILIATION *********************/
  uploadProofOfPayment(tripId, payload){
    return Axios({
      method: "POST",
      url: `booking-service/booking/booking-trip/${tripId}/upload_trip_documents/`,
      data: payload
    })
  },
  createOrganisationReconciliationProfile() {
    return Axios({
      method: 'POST',
      url: `booking-service/reconciliation/reconciliation-organisation-profile/`,
    });
  },

  getOrganisationReconciliationProfile() {
    return Axios({
      method: 'GET',
      url: `booking-service/reconciliation/reconciliation-organisation-profile/`,
    });
  },

  reconcileInventory(tripRef, payload) {
    return Axios({
      method: 'PATCH',
      url: `warehouse-service/inventory/orderset/reconcile/${tripRef}`,
      data: payload
    });
  },

  confirmReconciliation(tripID) {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-trip/${tripID}/confirm_ims_reconciliation/`,
    });
  },


  /*************** PRODUCTS ******************/
  getProducts(filter) {
    return Axios({
      method: 'GET',
      url: `warehouse-service/inventory/products/${filter}`
    })
  },

  createProduct(payload) {
    return Axios({
      method: 'POST',
      url: `warehouse-service/inventory/products/add-product`,
      data: payload,
    });
  },

  searchForProduct(payload) {
    return Axios({
      method: 'POST',
      url: `warehouse-service/inventory/products/search`,
      data: payload
    });
  },

  createProducts(payload) {
    return Axios({
      method: 'POST',
      url: `warehouse-service/inventory/products/add-products`,
      data: payload,
    });
  },

  updateProduct(id, payload) {
    return Axios({
      method: 'PATCH',
      url: `warehouse-service/inventory/products/update/${id}`,
      data: payload
    })
  },

  deleteProduct(id) {
    return Axios({
      method: 'DELETE',
      url: `warehouse-service/inventory/products/delete/${id}`,
    })
  },

  /*************** CATEGORIES ******************/

  getProductCategories() {
    return Axios({
      method: 'GET',
      url: `warehouse-service/inventory/category`
    })
  },

  addProductCategory(payload) {
    return Axios({
      method: 'POST',
      url: `warehouse-service/inventory/category/create`,
      data: payload,
    });
  },

  updateProductCategory(id, payload) {
    return Axios({
      method: 'PATCH',
      url: `warehouse-service/inventory/category/update/${id}`,
      data: payload
    })
  },

  deleteProductCategory(id) {
    return Axios({
      method: 'DELETE',
      url: `warehouse-service/inventory/category/delete/${id}`,
    })
  },

  /*************** ORDERS AND ORDERSETS ******************/
  createTripManifest(payload) {
    return Axios({
      method: 'POST',
      url: `warehouse-service/inventory/orderset/orderset-manifest`,
      data: payload
    })
  },

  createManifest(suffix, payload) {
    return Axios({
      method: 'POST',
      url: `warehouse-service/inventory/orderset/${suffix}`,
      data: payload
    })
  },

  getOrderSets(filter) {
    return Axios({
      method: 'GET',
      url: `warehouse-service/inventory/orderset/${filter}`
    })
  },

  getTripByOrderSetReference(filter) {
    return Axios({
      method: 'GET',
      url: `booking-service/booking/booking-trip/get_trip_by_orderset_reference/?orderset=${filter}`
    })
  },

  createOrderSet(payload) {
    return Axios({
      method: 'POST',
      url: `warehouse-service/inventory/orderset/create`,
      data: payload
    })
  },

  deleteOrderSet(ref) {
    return Axios({
      method: 'DELETE',
      url: `warehouse-service/inventory/orderset/delete-orderset/${ref}`,
    })
  },

  addOrders(payload) {
    return Axios({
      method: 'POST',
      url: `warehouse-service/inventory/orderset/orders`,
      data: payload
    })
  },

  updateOrder(orderSetRef, payload) {
    return Axios({
      method: 'PATCH',
      url: `warehouse-service/inventory/orderset/order/${orderSetRef}`,
      data: payload
    })
  },

  removeOrder(orderSetRef, payload) {
    return Axios({
      method: 'PATCH',
      url: `warehouse-service/inventory/orderset/remove-order/${orderSetRef}/`,
      data: payload
    })
  },

  assignMerchantToOrderSet(orderSetRef, payload) {
    return Axios({
      method: 'PATCH',
      url: `warehouse-service/inventory/orderset/assign-merchant/${orderSetRef}`,
      data: payload
    })
  },

};

export default BookingService;
